var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScenarioSplashPage',{attrs:{"primaryTitle":_vm.title,"primarySubtitle":_vm.subtitle,"secondaryContent":_vm.content,"buttonLabel":"Deploy","bgImage":_vm.bgImage},on:{"deploy":_vm.deploy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }